import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  Form,
  FormButton,
  FormTextarea,
  Text,
} from '@shared/components';
import { FormProvider, type UseFormReturn } from 'react-hook-form';

import { type CancelExamEventFormType } from '../../containers';

export interface CancelExamEventFormProps {
  form: UseFormReturn<CancelExamEventFormType>;
  onSubmit: (data: CancelExamEventFormType) => void;
  onClose: () => void;
}

export default function CancelExamEventForm(props: Readonly<CancelExamEventFormProps>) {
  const { form, onSubmit, onClose } = props;
  const { handleSubmit } = form;

  return (
    <FormProvider {...form}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <Text sx={{ mb: (theme) => theme.spacing(4) }}>
            คุณกำลังจะเปลี่ยนสถานะเป็น{' '}
            <Text variant='body1Semibold' component='span'>
              “ยกเลิกรอบสอบ”
            </Text>
            <br />
            ระบบจะไม่เปิดให้สมัครสอบในรายการนี้อีกต่อไป
          </Text>
          <FormTextarea
            name='reason'
            label='กรุณาระบุสาเหตุที่ยกเลิก'
            placeholder='กรุณาระบุสาเหตุที่ยกเลิก'
            required
            minRows={1}
          />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button color='secondary' variant='outlined' size='large' onClick={onClose}>
            ยกเลิก
          </Button>
          <FormButton color='error' size='large' label='ยกเลิกรอบสอบ' />
        </DialogActions>
      </Form>
    </FormProvider>
  );
}
